import React from 'react'
import Water from '../../static/images/expertise/water-tap.jpg'
import WasteWater from '../../static/images/expertise/water-tap.jpg'

const HomeCard = (props) => {
  return (
    <div className='section home-card'>
      <div className='container card'>
        <div className='row'>
          <div className='col-lg-6 text'>
            <div>
              <div className='heading-left'>{props.title}</div>
              <p>{props.content}</p>
            </div>
            <a href={props.redirection} className='btn btn-theme-inverse'>
              Know More
            </a>
          </div>
          <div className='col-lg-5 offset-lg-1'>
            <img src={props.image} className='' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeCard
